import { lightTheme } from "@/customTheme"
import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      stroke={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      d="M8.857 10.13a.46.46 0 1 1 .002.922.46.46 0 0 1-.002-.921Zm4.784 0a.46.46 0 1 1 .001.922.46.46 0 0 1-.001-.921Z"
    />
    <path
      fill={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      stroke={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      strokeWidth={0.672}
      d="M15.274 14.24c0 .555-.316 1.43-1 2.171-.674.729-1.687 1.308-3.062 1.308-1.375 0-2.39-.582-3.066-1.314-.688-.743-1.005-1.619-1.005-2.165 0-.036.002-.064.005-.085.027.003.064.008.115.019.108.023.242.061.417.112.695.203 1.836.55 3.534.55 1.698 0 2.837-.35 3.53-.554.174-.05.308-.09.415-.112a1.08 1.08 0 0 1 .112-.018c.002.022.005.05.005.088Z"
    />
    <path
      fill={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      stroke={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      strokeWidth={0.25}
      d="M18.545 10.934a.547.547 0 0 1 .684.418 8.158 8.158 0 1 1-6.88-6.59.547.547 0 0 1 .447.666.617.617 0 0 1-.69.467 7.002 7.002 0 1 0 6.002 5.749.617.617 0 0 1 .437-.71Z"
    />
    <path
      fill={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      d="M17.663 9.556c-.269 0-.42-.134-.454-.403a14.094 14.094 0 0 0-.197-1.18c-.063-.283-.168-.496-.312-.64-.145-.145-.367-.258-.666-.339-.3-.08-.721-.168-1.266-.262-.262-.047-.393-.198-.393-.454 0-.269.134-.42.403-.454.531-.074.947-.144 1.246-.212.3-.067.523-.173.67-.317.149-.145.255-.363.318-.656.064-.292.13-.701.197-1.225.034-.276.185-.414.454-.414s.42.141.454.424c.06.497.123.887.186 1.17.064.282.169.496.313.64.145.145.368.256.67.333.303.077.727.163 1.272.257.262.047.393.199.393.454 0 .262-.148.414-.444.454-.524.074-.934.148-1.23.222-.296.074-.516.185-.66.333-.145.148-.25.366-.314.655-.063.29-.126.686-.186 1.19-.034.283-.185.424-.454.424Z"
    />
  </svg>
)
export default SvgComponent
